import { FC } from "react";

import { CROSS_REMOVE_ICON_PATHS } from "mds/utils/icon-paths";
import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CrossRemoveIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    {CROSS_REMOVE_ICON_PATHS.map((d, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <path d={d} fill="currentColor" key={i} />
    ))}
  </svg>
);
